(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/outcome-pair-groups.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/outcome-pair-groups.js');
"use strict";


const ResultInclinationIndexes = svs.components.sport.tipsenShared.constants.ResultInclinationIndexes;
const OutcomePairGroups = _ref => {
  let outcomePairGroups = _ref.outcomePairGroups;
  return React.createElement("div", {
    className: "event__outcome_pairs"
  }, outcomePairGroups.map((outcomePairGroup, index) =>
  React.createElement("div", {
    className: "event__outcome_pairs_group",
    key: index
  }, React.createElement("div", {
    className: "event__outcome_pairs_group__title"
  }, ResultInclinationIndexes[index]), React.createElement("div", {
    className: "event__outcome_pairs_content"
  }, outcomePairGroup.map(outcomePair => React.createElement("div", {
    className: "event__outcome_pair__outcome",
    key: outcomePair
  }, React.createElement("span", {
    className: "event__outcome__home"
  }, outcomePair[0]), "-", React.createElement("span", {
    className: "event__outcome__away"
  }, outcomePair[1])))))));
};
setGlobal('svs.components.poolBetting.printableCoupon.OutcomePairGroups', OutcomePairGroups);

 })(window);